import { SharedState } from '$utils/sharedState.svelte';
import type { Sdk } from '@circles-sdk/sdk';
import { connectComethToCirclesV2Sdk } from '$services/circlesV2Utils/connectComethToCirclesV2';
import type { Address } from 'viem';

class StateCirclesSDK extends SharedState<Sdk> {
  public async load(address: Address) {
    const sdk = await connectComethToCirclesV2Sdk(address);

    if (!sdk) {
      throw new Error('Could not load Circles SDK.');
    }

    this.set(sdk);
  }

  get current(): Sdk {
    if (!this._current) {
      throw new Error('Circles SDK initialization failed.');
    }
    return this._current;
  }
}

export const stateCirclesSDK = new StateCirclesSDK(null);
